export enum CACHES {
    THUMBS = "thumbs",
    FACE_CROPS = "face-crops",
    FILES = "files",
}
